import React, { Fragment, useEffect, useRef, useState } from "react";
import { compose } from "redux";
import enhancer from "./visit-program-validator";
import Button from "../button/Button";
import Toaster from "../common/Toaster";
import EncryptDecrypt from "../../api/EncryptDecrypt";
import GroupServices from "../../api/GroupServices";
import { Input } from "reactstrap";

const VisitProgramModal = props => {
  const {
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    setFieldValue,
    onSubmit,
    values,
    action,
    service
  } = props;

  const [visitProgramList, setVisitProgramList] = useState([]);
  const [visitProgramsLoading, setVisitProgramsLoading] = useState(false);

  useEffect(() => {
    setVisitProgramsLoading(true);
    if (service) {
      GroupServices.listVisitProgram({ service_id: service })
        .then(res => {
          let data = EncryptDecrypt.decrypt(res.data);
          if (data.status) {
            setVisitProgramList(data.data);
            setVisitProgramsLoading(false);
          } else {
            if (toaster.current) toaster.current.error(data.message);
            setVisitProgramsLoading(false);
          }
        })
        .catch(err => {
          if (toaster.current) toaster.current.error(err.message);
          setVisitProgramsLoading(false);
        });
    }
  }, [service]);

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  const toaster = useRef();

  const hasParam = props.match.params.id;

  const handleSubmit = () => {
    let { values, isValid, handleSubmit } = props;

    if (isValid) {
      onSubmit(values, action);
      if (action === "add") {
        const params = {
          group_id: hasParam,
          visit_program_id: values.visit_program_id
        };
        GroupServices.addVisitProgram(params)
          .then(res => {
            let data = EncryptDecrypt.decrypt(res.data);
            if (data.status) {
              if (toaster.current) toaster.current.success(data.message);
            } else {
              if (toaster.current) toaster.current.error(data.message);
            }
          })
          .catch(err => {
            if (toaster.current) toaster.current.error(err.response);
          });
      } else if (action === "edit") {
        const params = {
          id: values.id,
          group_id: hasParam,
          visit_program_id: values.visit_program_id
        };
        GroupServices.editVisitProgram(params)
          .then(res => {
            let data = EncryptDecrypt.decrypt(res.data);
            if (data.status) {
              if (toaster.current) toaster.current.success(data.message);
            } else {
              if (toaster.current) toaster.current.error(data.message);
            }
          })
          .catch(err => {
            if (toaster.current) toaster.current.error(err.response);
          });
      }
    }

    handleSubmit();
  };

  return (
    <form>
      <div className="form-group">
        <label className="fs-16 medium-text">
          Visit Program <span className="asterisk">*</span>
        </label>
        <br />
        <Input
          type="select"
          name=""
          id="visit_program_id"
          onChange={handleChange}
          value={values.visit_program_id}
          onBlur={handleBlur}
        >
          <option value="">
            {visitProgramsLoading
              ? "Loading Visit Program.."
              : "Select Visit Program"}
          </option>
          {visitProgramList &&
            visitProgramList.map((type, i) => {
              return (
                <Fragment>
                  <option key={`option${i}`} value={type.id}>
                    {type.name}({type?.service?.name})
                  </option>
                </Fragment>
              );
            })}
        </Input>
        <Error field="visit_program_id" />
      </div>

      <div>
        <Button
          type="button"
          className="c-btn c-info form-button fs-16 demi-bold-text mr-10"
          style={{ maxWidth: "125px" }}
          onClick={() => handleSubmit()}
        >
          Submit
        </Button>
        <Button
          type="button"
          className="c-btn c-secondary form-button fs-16 demi-bold-text"
          style={{ maxWidth: "125px" }}
          onClick={props.toggle}
        >
          Close
        </Button>
      </div>
      <Toaster ref={toaster} />
    </form>
  );
};

export default compose(enhancer)(VisitProgramModal);
